module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[119]484.e8c919c.woff2";